import React from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import { Container } from "reactstrap";
// FTO UAT Round 2c (2026-08-24): this page family NEVER mounted a
// ToastContainer, so every toast fired by useFtoForm / useCoaForm —
// including "Employee comment is required." on Submit — rendered nowhere.
// The Submit button looked dead when validation (or the server) rejected
// the request. 43 other pages mount their own container; this one now does
// too, covering both the FTO and COA forms.
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DashboardPageHeader } from "../../Components/Common/DashboardKit";
import FtoForm from "./FtoForm";
import CoaForm from "./CoaForm";
import RequestDetails from "./RequestDetails";

const FtoRequestPage = () => {
    const { id } = useParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const isCoa = location.pathname.includes("/coa/");
    const recordId = id && id !== "new" ? parseInt(id, 10) : 0;
    // Owner 2026-10-09: the eye icon opens the details (?view=1); the pencil opens the form.
    const isView = recordId > 0 && searchParams.get("view") === "1";

    const title = isCoa
        ? (recordId ? `COA Request #${recordId}` : "New COA Request")
        : (recordId ? `FTO Request #${recordId}` : "New FTO Request");

    const subtitle = isCoa
        ? (recordId
            ? (isView ? "Details of this Change of Attendance request." : "Review and edit this Change of Attendance request.")
            : "Submit a new Change of Attendance request.")
        : (recordId
            ? (isView ? "Details of this Flexible Time Off request." : "Review and edit this Flexible Time Off request.")
            : "Submit a new Flexible Time Off request.");

    return (
        <div className="page-content">
            <Container fluid>
                <DashboardPageHeader
                    icon={isCoa ? "ri-home-gear-line" : "ri-calendar-event-line"}
                    eyebrow="Personal Attendance"
                    title={title}
                    subtitle={subtitle}
                    tone="blue"
                    breadcrumb={[
                        { label: "Dashboards", to: "/" },
                        { label: "Personal Attendance", to: "/personal-attendance" },
                        { label: recordId ? `#${recordId}` : "New" },
                    ]}
                />
                {isView
                    ? <RequestDetails kind={isCoa ? "coa" : "fto"} id={recordId} />
                    : isCoa
                        ? <CoaForm coaId={recordId} />
                        : <FtoForm ftoId={recordId} />
                }
                <ToastContainer closeButton={false} position="top-right" />
            </Container>
        </div>
    );
};

export default FtoRequestPage;
